import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-iframe-capital',
  templateUrl: './iframe-capital.component.html',
  styleUrls: ['./iframe-capital.component.scss'],
})
export class IframeCapitalComponent implements OnInit {
  @ViewChild('meuIframe') meuIframe: ElementRef;

  constructor() {}

  ngOnInit(): void {}

  ativarModoTelaCheia() {
    const iframeElement = this.meuIframe.nativeElement;
    if (iframeElement.requestFullscreen) {
      iframeElement.requestFullscreen();
    } else if (iframeElement.mozRequestFullScreen) {
      iframeElement.mozRequestFullScreen();
    } else if (iframeElement.webkitRequestFullscreen) {
      iframeElement.webkitRequestFullscreen();
    }
  }
}
